module.exports = __webpack_public_path__ + "img/horsepower.bec26d17.png";